<script lang="ts">
    const supporterForm = {
        image: "image/common/supporter-form-qr.png",
        url:   "https://forms.gle/qugKz7bbndH9r1bf8"
    }
</script>

<sction id="support-activity-section">
    <div class="container">
        <h2 class="container__title">Support Activity</h2>
        <ul class="container__content-area">  
            <li class="container__content-item">
                <div class="container__content-label">TOHO BANK</div>
                <div class="container__content-text">Aizu Apio branch（branch No.422）</div>
            </li>
            <li class="container__content-item">
                <div class="container__content-label">ORDINARY DEPOSIT</div>
                <div class="container__content-text">Account number：
                    <span class="container__content-text--important">214094</span>
                </div>
            </li>
            <li class="container__content-item">
                <div class="container__content-label">ACCOUNT NAME</div>
                <div class="container__content-text">ﾀﾅｶﾘｮｳｽｹﾌｯｶﾂｵｳｴﾝﾌﾟﾛｼﾞｪｸﾄ</div>
            </li>
            <div class="container__content-caution">※When making a transfer from an ATM, there is a limit to the number of characters in the name, <br>so please enter as much as possible.</div>
            <div class="container__content-form">
                <div class="container__content-form--left">
                    <div class="container__content-form-text">Please send him a message of support from <br>the QR code or button below.</div>
                    <div class="container__content-form-button">
                        <a class="container__content-form-button--link" href="{supporterForm.url}">Message Form</a>
                    </div>
                </div>
                <div class="container__content-form--right">
                    <img class="container__content-form-image" alt="Support Message Form QR code" src="{supporterForm.image}">
                </div>
            </div>
        </ul>
    </div>
</sction>

<style>
    #support-activity-section {
        display:          block;
        padding:          60px 0;
        background-color: #f0eee9;
    }

    #support-activity-section .container {
        width:  1024px;
        margin: 0 auto;
    }

    #support-activity-section .container__title{
        font-size:     40px;
        font-weight:   bold;
        color:         #333333;
        margin-bottom: 56px;
    }
    
    #support-activity-section .container__title:after {
        display:          block;
        position:         absolute;
        content:          "";
        height:           4px;
        width:            250px;
        background-color: #1a2382;
        transform:        translate(384px, 16px);
    }

    #support-activity-section .container__content-area {
        display:          block;
        margin:           0;
        padding:          40px 120px;
        background-color: white;
        border-radius:    8px;
        text-align:       left;
    }

    #support-activity-section .container__content-item {
        height:         48px;
        list-style:     none;
    }

    #support-activity-section .container__content-item:not(:last-child) {
        margin-bottom: 16px;
    }

    #support-activity-section .container__content-label {
        display:          inline-block;
        width:            224px;
        padding:          8px 0;
        margin:           0 50px 0 40px;
        text-align:       center;
        font-size:        20px;
        background-color: #1e1b79;
        color:            white;
        border-radius:    4px;
        vertical-align:   top;
    }

    #support-activity-section .container__content-text {
        display:     inline-block;
        font-size:   26px;
        font-weight: bold;
    }

    #support-activity-section .container__content-text--important {
        padding-left: 16px;
        font-size:    36px;
        color:        #2b2797;
    }

    #support-activity-section .container__content-caution {
        text-align:    center;
        margin-bottom: 40px;
    }

    /* form area ----------------------------------- */

    #support-activity-section .container__content-form {
        display: block;
    }

    #support-activity-section .container__content-form--left {
        display:        inline-block;
        width:          580px;
        margin-right:   8px;
        padding-top:    8px;
        vertical-align: top;
    }

    #support-activity-section .container__content-form-text {
        margin-bottom: 16px;
        font-size:     20px;
        font-weight:   bold;
        color:         #353535;
        text-align:    center;
    }

    #support-activity-section .container__content-form-button {
        text-align: center;
    }

    #support-activity-section .container__content-form-button a {
        padding:          10px 48px;
        font-size:        32px;
        font-weight:      bold;
        color:            white;
        border-radius:    8px;
        background-color: #ebaa06;
        transition:       0.8s;
    }

    #support-activity-section .container__content-form-button a:hover {
        padding:         12px 56px;
        font-size:       34px;
        opacity:         0.8;
        text-decoration: none;
    }

    #support-activity-section .container__content-form-button a:active {
        opacity:    0.6;
        transition: 0.1s;
    }

    #support-activity-section .container__content-form--right {
        display: inline-block;
        width:   150px;
    }

    #support-activity-section .container__content-form-image {
        width: 100%;
    }    
</style>